import React from 'react';
import ShowIf from '@Atoms/ShowIf';
import { useLearnosityExamAccess } from '@components/Component/LearnosityExams/ShowIfLearnosityExamFlagEnabled';
import { useFeatureFlagEnabled } from '@components/Atoms/FeatureFlagGuard/hooks';
import { FEATURE_SHOW_CALENDAR } from '@components/Atoms/FeatureFlagGuard/constants';
import { useReportsFeatureAccessQuery } from '@components/ReportGenerator/ReportQueries';
import { NavBarGroup, NavBarPrimary, InfoUserGroup } from './TopNavBar.style';
import NavBarItemComponent from './NavBarItemComponent';

const StudentNavBar = ({ state, props, navBarItemProps, renderUserIcon }) => {
  const { isDropdown } = state;
  const { user, curriculumDetail } = props;
  const isLearnosityExamEnabled = useLearnosityExamAccess();
  const showCalendar = useFeatureFlagEnabled({ featureName: FEATURE_SHOW_CALENDAR });
  const isStudentSkillLevelReportEnabled = useReportsFeatureAccessQuery('student_skill_level_report');

  return (
    <NavBarGroup>
      <NavBarPrimary>
        <NavBarItemComponent
          {...navBarItemProps}
          url="/dashboard/course/"
          icon="chalktalk-icon-home"
          dataTip=""
          label="Dashboard"
        />
        <NavBarItemComponent
          {...navBarItemProps}
          url="/lessons/course/"
          icon="chalktalk-icon-tech"
          dataTip=""
          label="Lessons"
        />
        <ShowIf If={curriculumDetail.has_exam && !isLearnosityExamEnabled}>
          <NavBarItemComponent
            {...navBarItemProps}
            url="/test/course/"
            icon="chalktalk-icon-note-list"
            dataTip=""
            label="Tests"
          />
        </ShowIf>
        <ShowIf If={curriculumDetail.has_exam && isLearnosityExamEnabled}>
          <NavBarItemComponent
            {...navBarItemProps}
            url="/tests/course/"
            icon="chalktalk-icon-note-list"
            dataTip=""
            label="Tests"
            actionRequiredKey={["LE"]}
          />
        </ShowIf>
        <ShowIf If={showCalendar === true}>
          <NavBarItemComponent
            {...navBarItemProps}
            url="/schedule/course/"
            icon="chalktalk-calendar"
            dataTip=""
            label="Calendar"
          />
        </ShowIf>
        <ShowIf If={isStudentSkillLevelReportEnabled}>
          <NavBarItemComponent
            {...navBarItemProps}
            url="/admin/reports/generator"
            icon="chalktalk-icon-reports"
            dataTip=""
            label="Reports"
            transform={false}
          />
        </ShowIf>
      </NavBarPrimary>
      <InfoUserGroup>
        <NavBarPrimary>
          <NavBarItemComponent
            {...navBarItemProps}
            url="/section-enroll"
            icon="chalktalk-course-plus"
            dataTip="Join section"
            label=""
            transform={false}
          />
          {renderUserIcon(user, isDropdown)}
        </NavBarPrimary>
      </InfoUserGroup>
    </NavBarGroup>
  );
};

export default StudentNavBar;
